
import { useRef } from 'react';
import emailjs from '@emailjs/browser';

function Contact() {
    const form = useRef();

    function submitContact(event) {
        event.preventDefault();
        emailjs
        .sendForm('service_twcl7gy', 'template_kk2lxm8', form.current, {
            publicKey: 'iKWXMmArwngHrpt-W',
        })
        .then(
            () => {
                form.current.reset();
                alert("Successfully submitted form!");
            },
            (error) => {
                form.current.reset();
                alert("Failed to submit form. Try again in a few minutes.")
            },
        );
    }

    return (
        <div>
            <div className="container-contact">
                <form ref={form} onSubmit={submitContact}>
                    <label>First Name</label>
                    <input type="text" id="fname" name="firstname" placeholder="Your name.."/>

                    <label>Last Name</label>
                    <input type="text" id="lname" name="lastname" placeholder="Your last name.."/>

                    <label>Email</label>
                    <input type="text" id="email" name="email" placeholder="Your email.."/>

                    <label>Description</label>
                    <textarea id="subject" name="desc" placeholder="Write something.." style={{height:"200px"}}></textarea>

                    <input type="submit" value="Submit"/>
                </form>
            </div>
        </div>
    )
}
export default Contact;